import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { Skeleton } from '@mui/lab';

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    display: 'grid',
    gridGap: '14px',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gridAutoRows: '120px',
    padding: '8px 0',
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    border: '1px solid #eee',
  },
  listHeader: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr 1fr 1.5fr 0.8fr',
    alignItems: 'center',
    backgroundColor: '#0076FF',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '13px',
    height: '50px',
    padding: '0 8px',
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    position: 'sticky',
    top: 0,
    zIndex: 2,
  },
  listItem: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr 1fr 1.5fr 0.8fr',
    alignItems: 'center',
    padding: '0 8px',
    fontSize: '13px',
    height: '40px',
    boxSizing: 'border-box',
    textAlign: 'left',
  },
  rowEven: { 
    backgroundColor: '#ffffff' 
  },
  rowOdd: { 
    backgroundColor: '#f9f9f9' 
  },
  skeleton: {
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    animation: '$skeleton-loading 1.5s infinite ease-in-out',
  },
  '@keyframes skeleton-loading': {
    '0%': {
      backgroundColor: '#f0f0f0',
    },
    '50%': {
      backgroundColor: '#e0e0e0',
    },
    '100%': {
      backgroundColor: '#f0f0f0',
    },
  },
}));

const SkeletonLoader = ({ viewMode = 'grid', itemCount = 6 }) => {
  const classes = useStyles();

  const renderGridSkeletons = () => {
    return Array.from({ length: itemCount }).map((_, index) => (
      <Box key={index} style={{ width: '120px', height: '130px' }}>
        <Skeleton 
          variant="rect" 
          width="100%" 
          height="100%" 
          animation="wave"
          className={classes.skeleton}
        />
      </Box>
    ));
  };

  const renderListSkeletons = () => {
    return (
      <div className={classes.listContainer}>
        {/* Header */}
        <div className={classes.listHeader}>
          <div>Name</div>
          <div>Team</div>
          <div>Size</div>
          <div>Date Added</div>
          <div></div>
        </div>
        
        {/* Skeleton rows */}
        {Array.from({ length: itemCount }).map((_, index) => (
          <div 
            key={index} 
            className={`${classes.listItem} ${
              index % 2 === 0 ? classes.rowEven : classes.rowOdd
            }`}
          >
            <Skeleton 
              variant="text" 
              width="60%" 
              height="20px"
              animation="wave"
              className={classes.skeleton}
            />
            <Skeleton 
              variant="text" 
              width="40%" 
              height="20px"
              animation="wave"
              className={classes.skeleton}
            />
            <Skeleton 
              variant="text" 
              width="30%" 
              height="20px"
              animation="wave"
              className={classes.skeleton}
            />
            <Skeleton 
              variant="text" 
              width="20%" 
              height="20px"
              animation="wave"
              className={classes.skeleton}
            />
            <Skeleton 
              variant="circle" 
              width="24px" 
              height="24px"
              animation="wave"
              className={classes.skeleton}
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={viewMode === 'grid' ? classes.gridContainer : ''}>
      {viewMode === 'grid' ? renderGridSkeletons() : renderListSkeletons()}
    </div>
  );
};

export default SkeletonLoader;
